import { Question } from 'survey-core'

export const CUSTOM_TYPE = 'surveytrackingcards'

export class SurveyTrackingCardsQuestion extends Question {
  constructor (name: string) {
    super(name)
    this.titleLocation = 'hidden'
    this.isRequired = false
    this.value = 'displayed'
  }

  getType (): string {
    return CUSTOM_TYPE
  }

  // eslint-disable-next-line @typescript-eslint/class-literal-property-style
  get isReadOnly (): boolean {
    return false
  }

  get planOrganizationId (): number {
    return this.getPropertyValue('planOrganizationId') ?? 0
  }

  set planOrganizationId (val: number) {
    this.setPropertyValue('planOrganizationId', val)
  }

  get priorityBasePath (): string {
    return this.getPropertyValue('priorityBasePath') ?? ''
  }

  set priorityBasePath (val: string) {
    this.setPropertyValue('priorityBasePath', val)
  }
}
